export default __webpack_public_path__ + "static/media/get-started-rings.60093756.svg";